class VerifyPhoneOTP extends HTMLElement {
    constructor() {
        super();
        this.buttonSendOTP = null;
        this.inputOTP = null;
        this.inputPhone = null;
        this.btnSubmit = null;
        this.handleSendOTP = this.onSendOTP.bind(this);
        this.handleSubmitForm = this.onSubmitForm.bind(this);
    }

    connectedCallback() {
        this.buttonSendOTP = document.getElementById("btn-send-otp");
        this.inputOTP = document.getElementById("RegisterForm-otp");
        this.inputPhone = document.getElementById("RegisterForm-tel");
        this.btnSubmit = document.getElementById("submit-form-register");


        if (this.buttonSendOTP) {
            this.buttonSendOTP.removeEventListener("click", this.handleSendOTP);
            this.buttonSendOTP.addEventListener("click", this.handleSendOTP);
        }
        if (this.btnSubmit) {
            this.btnSubmit.removeEventListener("click", this.handleSubmitForm);
            this.btnSubmit.addEventListener("click", this.handleSubmitForm);
        }
    }

    onSendOTP(e) {
        e.preventDefault();
        this.sendOTP();

        this.buttonSendOTP.disabled = true;
        let remainingTime = 5;
        this.buttonSendOTP.innerText = `${remainingTime}s`;

        const countdown = setInterval(() => {
            remainingTime--;
            this.buttonSendOTP.innerText = `${remainingTime}s`;

            if (remainingTime <= 0) {
                clearInterval(countdown);
                this.buttonSendOTP.disabled = false;
                this.buttonSendOTP.innerText = "Send";
            }
        }, 1000);
    }

    onSubmitForm(e) {
        e.preventDefault();
        const inputOTP = document.getElementById("RegisterForm-otp");
        const inputPhone = document.getElementById("RegisterForm-tel");
        const responseOTP = document.getElementById("response-otp");
        const verifyOTP = document.getElementById("verify-otp");
        const modalLoading = document.getElementById("modal-loading");
    
        if (inputPhone.value === "") {
            responseOTP.innerHTML = "Vui lòng nhập số điện thoại";
            responseOTP.style.color = "red";
            inputPhone.focus();
            return;
        }
    
        if (inputOTP.value === "") {
            verifyOTP.innerHTML = "Vui lòng ấn SEND để nhận mã OTP";
            verifyOTP.style.color = "red";
            inputOTP.focus();
            return;
        }
        modalLoading.classList.add("active");
        this.validateOTP();
    }    

    sendOTP() {
        const phoneNumber =  document.getElementById("RegisterForm-tel");
        const url = `https://twilio-b5a9c.web.app/api/public/verify`;
        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ phoneNumber: phoneNumber.value }),
        })
            .then((response) => response.json())
            .then((data) => {
                const responseOTP = document.getElementById("response-otp");
                if (data?.success === true) {
                    responseOTP.innerHTML = "OTP sent successfully!";
                    responseOTP.style.color = "green";
                }
                else {
                    responseOTP.innerHTML = data?.message || "An error occurred. Please try again.";
                    responseOTP.style.color = "red";
                }
                if (data?.error) {
                    responseOTP.innerHTML = data.error;
                    responseOTP.style.color = "red";
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    validateOTP() {
        const phoneNumber =  document.getElementById("RegisterForm-tel");
        const inputOTP = document.getElementById("RegisterForm-otp");
        const url = `https://twilio-b5a9c.web.app/api/public/verify/${phoneNumber.value}?code=${inputOTP.value}`;
        fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((data) => {
                const modalLoading = document.getElementById("modal-loading");
                modalLoading.classList.remove("active");
                const verifyOTP = document.getElementById("verify-otp");
                if (data?.success == true) {
                    verifyOTP.innerHTML = data?.message || "OTP verified successfully!";
                    verifyOTP.style.color = "green";
                    document.querySelector("form#create_customer").submit();
                }
                else {
                    verifyOTP.innerHTML = data?.message || "An error occurred. Please try again.";
                    verifyOTP.style.color = "red";
                }
                if (data?.error) {
                    verifyOTP.innerHTML = data.error;
                    verifyOTP.style.color = "red";
                }
            })
            .catch((error) => {
                console.error(error);
            });

    }
}

customElements.define("verify-phone-otp", VerifyPhoneOTP);
